import { Component, ElementRef, signal } from '@angular/core';
import { AudioEffectPlayer } from '../../utils/audio.utils';
import { RidDraggable } from '../rid-draggable/rid-draggable';

@Component({
  selector: 'rid-drop-zone',
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `,
  host: {
    class: 'block',
  },
})
export class RidDropZone {
  private snapped = signal<RidDraggable[]>([]);

  private el: HTMLElement;

  constructor(elRef: ElementRef<HTMLElement>) {
    this.el = elRef.nativeElement;
  }

  private snap(draggable: RidDraggable) {
    this.snapped.set([...this.snapped(), draggable]);

    const center = this.getCenter();
    draggable.snapTo(center.x, center.y);
    AudioEffectPlayer.play('POP');
  }

  public unsnap(draggable: RidDraggable) {
    this.snapped.set(this.snapped().filter((d) => d !== draggable));
    draggable.unsnap();
  }

  public isSnapped(draggable: RidDraggable): boolean {
    return this.snapped().includes(draggable);
  }

  public handleMove(draggable: RidDraggable, point: { x: number; y: number }) {
    if (this.containsPoint(point)) {
      if (!this.isSnapped(draggable)) {
        this.snap(draggable);
      }
    } else if (this.isSnapped(draggable)) {
      this.unsnap(draggable);
    }
  }

  private containsPoint(point: { x: number; y: number }): boolean {
    const rect = this.el.getBoundingClientRect();
    return point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom;
  }

  private getCenter(): { x: number; y: number } {
    const rect = this.el.getBoundingClientRect();
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }
}
